/**
 *
 * 国家名 检索
 *
 */
export const areaTranslations = new Map([
    ["asia", "亚洲"],
    ["europe", "欧洲"],
    ["north-america", "北美"],
    ["africa", "非洲"],
    ["antarctica", "南极洲"],
    ["central-america", "中美洲"],
    ["oceania", "大洋洲"],
    ["south-america", "南美洲"],
  ]);